<template>
    <button class="flex bg-black text-[16px] text-white jusify-center py-[20px] justify-center rounded-[6px] gap-[15px] w-full" @click="sendPaymentRequest">
        {{ buttonText }}
        <img class="w-[123px]" width="123" height="14" src="/img/monocheckout.svg" alt="" />
    </button>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { usePromoCodeStore } from "@/stores/promoCode";

const config = useRuntimeConfig();
const promoStore = usePromoCodeStore();
const { $getCookie } = useNuxtApp();

const props = defineProps({
    paymentMethod: {
        type: String,
        default: "card",
    },
    buttonText: {
        type: String,
        default: "Оформити через",
    },
});

const emit = defineEmits(["payment-sent", "payment-error", "payment-method-change"]);

const apiUrl = config.public.apiUrl;

const sendPaymentRequest = async () => {
    emit("payment-method-change", props.paymentMethod);

    try {
        const cartFromLocalStorage = JSON.parse(localStorage.getItem("cart")) || [];
        const response = await fetch(apiUrl + "order/monocheckout", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                paymentMethod: props.paymentMethod,
                promoCode: promoStore.getPromoCode,
                cart: cartFromLocalStorage,
                utm: $getCookie("utm"),
            }),
        });
        const result = await response.json();
        if (result.payment_url) {
            window.location.href = result.payment_url;
        } else {
            console.error("Payment URL is missing in the response:", result);
            emit("payment-error", new Error("Payment URL is missing"));
        }
        emit("payment-sent", result);
    } catch (error) {
        console.error("Ошибка при отправке запроса:", error);
        emit("payment-error", error);
    }
};
</script>

<style lang="scss" scoped>
/* Анимация блеска на кнопке */
.shine-effect {
    position: relative;
    overflow: hidden;
    color: #fff;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.button-monocheckout {
    width: 100%;
}

// .shine-effect::before {
//     content: "";
//     position: absolute;
//     top: -100%;
//     left: -100%;
//     width: 200%;
//     height: 200%;
//     background: linear-gradient(45deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
//     transform: rotate(45deg);
//     animation: shine 2s infinite;
// }

// @keyframes shine {
//     0% {
//         transform: translate(-100%, -100%) rotate(45deg);
//     }
//     100% {
//         transform: translate(100%, 100%) rotate(45deg);
//     }
// }
</style>
